module.exports = __webpack_public_path__ + "static/media/imil.0aea8a53.png";